import React from "react";
import useJumboApp from "@jumbo/hooks/useJumboApp";
import { config } from "../../../app/config/main";

// TODO: Add right types as we shift to TypeScript
interface PageProps {
  component: React.ComponentType<any>;
  layout?: string;
  [key: string]: any;
}

const Page = ({
  component,
  layout = config.defaultLayout,
  ...restProps
}: PageProps) => {
  const { activeLayout, setActiveLayout } = useJumboApp();

  React.useEffect(() => {
    if (layout !== activeLayout) {
      setActiveLayout(layout);
    }
  }, [layout]);

  const PageComponent = component;

  return <PageComponent {...restProps} />;
};

export default Page;
